module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/past-projects/15shorts@2x-e331e24d69238268e86f64e867691c59.jpg";